module.exports = __webpack_public_path__ + "img/53.4c5f6dff.jpg";